export const environment = {
  production: true,
  version: 'v1',
  addressHostName: 'https://nominatim.openstreetmap.org',
  apiHostName:
    'https://prod-api-zoei-fnffeshbdngbcsfw.centralindia-01.azurewebsites.net',
  //apiHostName: 'https://localhost:7261',
  //apiHostName: 'https://r67cr99j-7261.inc1.devtunnels.ms',
};
